import { Button } from "@/components/ui/button"
import { ArrowRight, ChevronDown } from "lucide-react"
import Link from "next/link"

export function HeroSection() {
  return (
    <section
      id="hero"
      className="relative flex min-h-[100dvh] items-center justify-center overflow-hidden"
      aria-label="Ana sayfa başlık alanı"
    >
      <div className="absolute inset-0 bg-grid bg-grid-fade opacity-40" aria-hidden="true" />
      <div className="hidden lg:block absolute top-1/4 left-1/4 w-96 h-96 bg-primary/20 rounded-full blur-[128px] animate-pulse" aria-hidden="true" />
      <div className="hidden lg:block absolute bottom-1/4 right-1/4 w-96 h-96 bg-accent/15 rounded-full blur-[128px] animate-pulse delay-1000" aria-hidden="true" />

      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 pt-20 sm:pt-32 pb-12 sm:pb-20 max-w-6xl">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="font-[family-name:var(--font-heading)] text-fluid-hero font-bold mb-5 sm:mb-6">
            <span className="text-gradient-brand">Vizyonunuzu</span>
            <br />
            <span className="text-foreground">Koda Döküyoruz</span>
          </h1>

          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-10 leading-snug sm:leading-relaxed">
            Next.js, React Native ve özel sistem çözümleriyle fikirlerinizi,
            rakiplerinizi geride bırakan dijital ürünlere dönüştürüyoruz.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 w-full max-w-md mx-auto sm:max-w-none">
            <Button
              asChild
              size="lg"
              className="bg-primary hover:bg-primary/90 active:scale-[0.98] text-primary-foreground w-full sm:w-auto px-6 py-6 sm:px-8 sm:py-6 text-[15px] sm:text-lg font-semibold rounded-2xl sm:rounded-xl transition-all shadow-lg shadow-primary/25 group"
            >
              <Link href="#iletisim">
                Ücretsiz Keşif Görüşmesi
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" aria-hidden="true" />
              </Link>
            </Button>
            <Button
              asChild
              variant="outline"
              size="lg"
              className="border border-border/50 bg-secondary/50 backdrop-blur-sm hover:border-foreground/30 hover:bg-secondary active:scale-[0.98] w-full sm:w-auto px-6 py-6 sm:px-8 sm:py-6 text-[15px] sm:text-lg font-semibold rounded-2xl sm:rounded-xl transition-all"
            >
              <Link href="#projeler">Projelerimizi İncele</Link>
            </Button>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mt-6 text-sm text-muted-foreground">
            <span className="flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 rounded-full bg-green-500 inline-block" aria-hidden="true" />
              3 iş günü içinde yanıt
            </span>
            <span className="flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 rounded-full bg-green-500 inline-block" aria-hidden="true" />
              50+ tamamlanan proje
            </span>
            <span className="flex items-center gap-1.5">
              <span className="w-1.5 h-1.5 rounded-full bg-green-500 inline-block" aria-hidden="true" />
              NDA ile gizlilik garantisi
            </span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <Link href="#hakkimizda" aria-label="Aşağı kaydır" className="w-8 h-8 flex items-center justify-center text-muted-foreground/70 hover:text-primary transition-colors animate-bounce">
          <ChevronDown className="w-6 h-6" aria-hidden="true" />
        </Link>
      </div>
    </section>
  )
}
